import { render, staticRenderFns } from "./AddEditAnnouncement.vue?vue&type=template&id=022773c9"
import script from "./AddEditAnnouncement.vue?vue&type=script&lang=js"
export * from "./AddEditAnnouncement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports